import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { colors } from "../../../../components/theme";

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontSize: "12px",
    fontWeight: "lighter",
  },
}));

export const WrapperTextShort = styled.div`
  width: 100%;
  padding: 20px;
  overflow: hidden;
  border-radius: 4px;
  display: inline-block;
  background-color: white;
`;

export const Container = styled.div`
  width: 100%;
  background-color: ${colors.white};
  position: relative;
  height: auto;
`;
export const Title = styled.h4`
  color: #0076ff;
  margin: 0px auto;
  text-align: left;
  font-weight: 900;
  position: absolute;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ContainerTools = styled.section`
  display: flex;
  width: 100%;
  height: 23px;
  margin-top: 15px;
  justify-content: space-between;
`;

export const ContainerTextField = styled.div`
  width: 100%;
`;

export const DivHelperTextTitle = styled.div`
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 12px;
`;
